/**
 * The company's logo, or its initial on the brand tint — the same mark on
 * everything a company asks of the citizen: its invitations and its
 * sponsorship offers, on Home, in the bell and in their dialogs.
 */
import { Building2 } from '@tonnie/assets';

export function CompanyMark({ name, logo }: { name: string; logo: string | null }) {
  if (logo) {
    return (
      <img
        src={logo}
        alt=""
        className="h-10 w-10 rounded-lg object-cover border border-border shrink-0"
      />
    );
  }
  const initial = name.trim().charAt(0).toUpperCase();
  return (
    <div
      className="h-10 w-10 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center text-primary-accessible font-semibold shrink-0"
      aria-hidden="true"
    >
      {initial || <Building2 className="w-5 h-5" />}
    </div>
  );
}
